import { render, staticRenderFns } from "./BatchTransferAccounts.vue?vue&type=template&id=a1a9dcaa&scoped=true&"
import script from "./BatchTransferAccounts.vue?vue&type=script&lang=js&"
export * from "./BatchTransferAccounts.vue?vue&type=script&lang=js&"
import style0 from "./BatchTransferAccounts.vue?vue&type=style&index=0&id=a1a9dcaa&lang=less&scoped=true&"
import style1 from "./BatchTransferAccounts.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a9dcaa",
  null
  
)

export default component.exports